import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as myCfg from '../AppConfig';
import { sawinFunc, ResetStore, APIContainer, LogTypes } from './sawinLib';
import * as contactMdls from '../models/ServiceContactModel';

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface ServiceContactLoad { type: 'SERVICECONTACT_LOAD', newState: contactMdls.ServiceContactList }
export interface ServiceContactLoading { type: 'SERVICECONTACT_LOADING' }
export interface ServiceContactDelete { type: 'SERVICECONTACT_DELETE' }
export interface ServiceContactError { type: 'SERVICECONTACT_ERROR', error: string }

export type KnownAction = ServiceContactLoad | ServiceContactLoading | ServiceContactError | ResetStore;

export const actionCreators = {
    loadServiceContact: () : AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const pSession = appState.sessionState;

        var ServiceMasterNumber = pSession.SelectedSM.id;
        var CompanyCode = pSession.SelectedAR.companyCode;

        dispatch({ type: 'SERVICECONTACT_LOADING' });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/Proxy/ServiceContact?ServiceMaster=' + ServiceMasterNumber + '&CompanyCode=' + CompanyCode,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
                if (container.success) {
                    const data: contactMdls.ServiceContactModel[] = container.data;
                    dispatch({ type: 'SERVICECONTACT_LOAD', newState: { items: data, loading: false, error: '' } });
                } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                }
            });

    },
    deleteServiceContact: (contactSeq: number): AppThunkAction<KnownAction> => (dispatch, getState) => {

        const appState = getState();
        const pSession = appState.sessionState;

        var ServiceMasterNumber = pSession.SelectedSM.id;
        var CompanyCode = pSession.SelectedAR.companyCode;
        if (window.confirm("Do you want to delete this Contact?")) {

            sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + `api/Proxy/ServiceContact?ServiceMaster=${ServiceMasterNumber}&CompanyCode=${CompanyCode}&Sequence=${contactSeq}`,
                {
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(response => response.json() as Promise<APIContainer>)
                .then(container => {
                    if (container.success) {
                        var data: contactMdls.ServiceContactModel[] = appState.serviceContactState.items;
                        data = data.filter(x => x.sequence != contactSeq);
                        //const data: contactMdls.ServiceContactModel[] = container.data;
                        dispatch({ type: 'SERVICECONTACT_LOAD', newState: { items: data, loading: false, error: '' } });
                    } else {
                        sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                        dispatch({
                            type: 'SERVICECONTACT_ERROR', error: container.errorInfo.message
                        })
                    }
                });
        }
    }
};

export const reducer: Reducer<contactMdls.ServiceContactList> = (state: contactMdls.ServiceContactList | undefined, incomingAction: Action): contactMdls.ServiceContactList => {

    if (state === undefined) {
        return { ...contactMdls.initialStateServiceContactList };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'SERVICECONTACT_LOADING':
            return { ...state, loading: true }
        case 'SERVICECONTACT_LOAD':
            const loadHistoryAction = incomingAction as ServiceContactLoad;
            return { ...state, ...loadHistoryAction.newState, loading: false }
        case 'SERVICECONTACT_ERROR':
            return { ...state, loading: false, error: (action as ServiceContactError).error }
        case 'STORE_RESET':
            return { ...contactMdls.initialStateServiceContactList };
        default:
            return state;
    }
};
